module.exports = __webpack_public_path__ + "static/media/cat-lg-3.782a019f.jpg";